<template>
  <v-dialog
    v-model="startedOnDialog"
    persistent
    scrollable
    max-width="500"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        @click="startedOnDialogInit"
      >
        <v-icon>mdi-clock-start</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('supportTicketDialogEndedOn.title') }}
      </v-card-title>
      <v-card-text>
        <Loading :loading="!loaded" />

        <v-container
          v-if="loaded && startedOnModel"
          fluid
        >
          <v-row align="center">
            <v-col class="d-flex align-center">
              <v-datetime-picker
                v-model="startedOnModel.data.startedOn"
                use-iso
                :label="$t('common.timeLabel')"
                date-format="yyyy-MM-dd"
                time-format="HH:mm:ss"
                :time-picker-props="timeProps"
                @input="hasChanged = true"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
                <template
                  slot="actions"
                  slot-scope="{ parent }"
                >
                  <v-btn
                    outlined
                    color="primary"
                    @click.native="parent.cancelHandler"
                  >
                    {{ $t('common.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    @click="parent.okHandler"
                  >
                    {{ $t('common.ok') }}
                  </v-btn>
                </template>
              </v-datetime-picker>

              <v-btn
                class="ml-4"
                outlined
                small
                @click="startedOnModel.data.startedOn = new Date(); hasChanged = true"
              >
                {{ $t('common.now') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="startedOnModel.data.comment"
                :label="$t('common.comment')"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="startedOnDialogCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="!hasChanged"
          @click="startedOnDialogSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading'

export default {
  name: "SupportTicketDialogStartedOn",
  components: {
    Loading
  },
  props: {},
  data() {
    return {
      startedOnModel: Object,
      startedOnDialog: false,
      loaded: false,
      saving: false,
      hasChanged: false,
      timeProps: {
        format: "24hr",
        useSeconds: true,
      },
    };
  },
  methods: {
    startedOnDialogInit: function () {
      this.loaded = false;
      this.hasChanged = false;
      this.startedOnDialog = true;

      this.$api.get(`supportticket/startedon/${this.$route.params.id}`).then((response) => {
        this.startedOnModel = response.data;
        this.loaded = true;
      });
    },
    startedOnDialogSave: function () {
      this.saving = true;

      this.$api.put(`supportticket/startedon/${this.$route.params.id}`, this.startedOnModel.data).then((response) => {
        if (response.data.success) {
          this.saving = false;
          this.startedOnDialog = false;
          this.$emit("saved");
        } else {
          //TODO: Error handle...
        }
      });
    },
    startedOnDialogCancel: function () {
      this.startedOnModel = null;
      this.startedOnDialog = false;
    },
  },
};
</script>